import { AddressViaCepData } from "@/types/address-via-cep";
import axios from "axios";

const BASE_URL = 'https://viacep.com.br/ws';
const TIMEOUT = 5000;

export const viaCepService = {
  getAddress: async (zipCode: string): Promise<AddressViaCepData> => {
    try {
      const response = await axios.get<AddressViaCepData>(
        `${BASE_URL}/${zipCode}/json/`,
        {
          timeout: TIMEOUT,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        }
      );

      if ('erro' in response.data) {
        throw new Error('CEP não encontrado');
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.code === 'ECONNABORTED') {
          throw new Error('Timeout na consulta do CEP');
        }
        if (error.response?.status === 404) {
          throw new Error('CEP não encontrado');
        }
      }
      throw new Error('Erro ao buscar endereço via CEP');
    }
  }
};
